import React, {FC, useEffect, useRef} from "react";
import {Box} from "@chakra-ui/react";
import {PREVIEW_EMAIL_CSS} from "../../shared/utils/inactiveOrderReminderEmailPreview";

type Props = {
    bodyHtml: string;
    minHeight?: number | string;
    maxHeight?: number | string;
};

/** Рендер HTML письма в Shadow DOM — стили не попадают в текст. */
export const EmailPreviewShadow: FC<Props> = ({bodyHtml, minHeight = 200, maxHeight = "70vh"}) => {
    const hostRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const host = hostRef.current;
        if (!host) {
            return;
        }
        const shadow = host.shadowRoot ?? host.attachShadow({mode: "open"});
        shadow.innerHTML = `<style>${PREVIEW_EMAIL_CSS}</style><div class="email-preview-body">${bodyHtml || ""}</div>`;
    }, [bodyHtml]);

    return (
        <Box
            ref={hostRef}
            bg="white"
            w="100%"
            minH={minHeight}
            maxH={maxHeight}
            overflowY="auto"
        />
    );
};

export default EmailPreviewShadow;
